import React from 'react';
import { max } from 'js-media-query';
import { Ui }from '@einstein/schedule-platform';

import {
  Section,
  Container,
  Wrapper,
  TextContainer,
  Title,
  Card,
  ButtonContainer,
  ImageSection
} from './styles';

const Image =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/CareTeam/image.png';
const Image2x =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/CareTeam/image@2x.png';
const CalendarCircleIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/calendar-circle.svg';
const StethScopeCircleIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/stethoscope-circle.svg';
const HeartPulseCircleIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home/Icons/heartpulse-circle.svg';

type CareTeamProps = {
  handleSchedule: () => void;
  hasProductError?: boolean;
};

const CareTeam = ({ handleSchedule, hasProductError }: CareTeamProps) => {
  return (
    <Section id="equipe-de-cuidado">
      <Container>
        <Wrapper>
          <ImageSection src={max(900) ? Image : Image2x} />
          <TextContainer>
            <Title>Equipe de cuidado</Title>
            <Card width={380}>
              <img src={CalendarCircleIcon} alt="" />
              <p>Agende on-line consultas presenciais ou por telemedicina.</p>
            </Card>
            <Card>
              <img src={StethScopeCircleIcon} alt="" />
              <p>
                Equipe formada por médico e enfermeiro de família das Clínicas
                Einstein.
              </p>
            </Card>
            <Card width={360}>
              <img src={HeartPulseCircleIcon} alt="" />
              <p>Acompanhamento completo da sua saúde.</p>
            </Card>
            <ButtonContainer>
              <Ui.Button
                title={
                  !hasProductError ? 'Agendar' : 'Agendamento não disponível'
                }
                disabled={!!hasProductError}
                onClick={handleSchedule}
              />
            </ButtonContainer>
          </TextContainer>
        </Wrapper>
      </Container>
    </Section>
  );
};

export default CareTeam;
